/**
 * Render a span of seconds as prose, for "Thought for …".
 */
export function formatDuration(totalSeconds: number): string {
	if (totalSeconds < 1) {
		return "less than a second";
	}

	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = Math.floor(totalSeconds % 60);

	const parts: string[] = [];

	if (hours > 0) {
		parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
	}
	if (minutes > 0) {
		parts.push(`${minutes} ${minutes === 1 ? "minute" : "minutes"}`);
	}
	// Seconds are shown under an hour, or when nothing else would be.
	if (hours === 0 && (seconds > 0 || parts.length === 0)) {
		parts.push(`${seconds} ${seconds === 1 ? "second" : "seconds"}`);
	}

	return parts.join(" ");
}
